import React from 'react';
import { Typography } from 'antd';
import { useFela } from 'react-fela';
import { FelaStyle } from 'src/fela';
import { useTranslation } from 'react-i18next';
import MyworkLogo from 'src/commons/components/Logo';

const { Text } = Typography;

type FileUploadProps = {
  validCpf: string;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function FileUpload(validCpf: FileUploadProps) {
  const { css } = useFela();
  const { t } = useTranslation();

  return (
    <div className={css(styles.container)}>
      <div className={css(styles.logo)}>
        <MyworkLogo height={50} />
      </div>
      <Text strong>
        {t('medicalCertificates.uploadByEmployee.cpfValidation.title')}
      </Text>
    </div>
  );
}

const styles: FelaStyle = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    textAlign: 'center',
  },
  logo: {
    alignSelf: 'center',
    paddingBottom: '1.5rem',
  },
};
